import { useContext, useMemo } from "react";
import AppContext from "../context/AppContext";
import { dirForLang, isRTL } from "../utils/rtl";

const useDirection = () => {
  const { langMode } = useContext(AppContext);

  return useMemo(() => {
    const rtl = isRTL(langMode);

    return {
      dir: dirForLang(langMode),
      isRTL: rtl,
      isLTR: !rtl,
      langMode,
      textAlign: rtl ? "text-right" : "text-left",
      textAlignStart: "text-start",
      flexRow: rtl ? "flex-row-reverse" : "flex-row",
    };
  }, [langMode]);
};

export default useDirection;
